module.exports = __webpack_public_path__ + "img/warranty.c7811759.svg";